import {get} from "@/tools/http";

export default {
    namespaced: true,

    state: {},
    mutations: {},
    actions: {
        setTag: (ctx, {type, tag}) => {
            ctx.dispatch(`${type}/setHashTag`, {tag: tag}, { root: true });
        },
    },
    getters: {},
};
